<template>
    <div class="page exams-page py-2 py-lg-6">
        <v-container :class="{'px-2': phoneOnly}">
            <v-card class="px-lg-5 py-lg-4 mx-auto p-relative overflow-hidden lg:bordered" :flat="phoneOnly" max-width="900" style="border-radius: 8px!important;">
                <v-progress-linear v-if="loading && pcOnly" :active="loading" :indeterminate="loading" height="2" absolute top color="secondary" ></v-progress-linear>
                <v-btn v-if="exam" icon absolute top left color="muted" :to="course_id ? {name: 'course', params: {id: course_id}} : undefined" @click="course_id ? undefined : exam = null">
                    <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
                <transition name="scroll-x-reverse-transition" mode="out-in">
                    <div v-if="!exam" class="d-flex align-center" :key="0">
                        <div v-if="mdAndUp" style="min-width: 330px; min-height: 330px">
                            <img :src="asset('exam-vector.svg', 'img')" style="height: 330px" />
                            <!-- <img :src="asset('exam-vector2.svg', 'img')" style="width: 370px" class="my-8" /> -->
                        </div>
                        <div class="ps-lg-10 pb-lg-6 mx-md-auto" :class="{'w-100': phoneOnly}">
                            <v-card-title class="justify-center mb-1">الامتحان اﻹلكتروني</v-card-title>
                            <template v-if="!course_id && enableGenericExams">
                            <v-card-subtitle class="text-center muted--text" :class="{'details-text': phoneOnly}">أدخل الكود الذي تسلمته لتتمكن من الدخول للامتحان</v-card-subtitle>

                            <v-card-text class="mt-3">
                                <v-form @submit.prevent="submit">
                                    <v-text-field v-model="exam_code" clearable color="primary" outlined label="كود الامتحان" hide-details class="exam-code-input"></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions class="pa-4 pt-2">
                                <v-btn :disabled="!exam_code" :loading="loading" depressed large color="primary" block class="px-6" @click="submit">
                                    <v-icon size="22" left>mdi-clipboard-text-outline</v-icon>
                                    الدخول إلى الامتحان
                                </v-btn>
                            </v-card-actions>

                            </template>
                            <template v-else>
                                <v-card-subtitle>يمكنك الدخول إلى الامتحان من صفحة الدورة..</v-card-subtitle>
                                <v-btn v-if="course_id" class="my-2" color="primary" block :to="{name: 'course', params: {id: course_id}}"> 
                                    العودة للدورة
                                    <v-icon right>mdi-arrow-right</v-icon>
                                </v-btn>
                                <v-btn v-else class="my-2" color="primary" block :to="{name: 'my-courses'}"> 
                                    الذهاب إلى دوراتي
                                    <v-icon right>mdi-arrow-right</v-icon>
                                </v-btn>
                            </template>
                        </div>
                    </div>
                    <div v-else class="d-flex align-center" :key="1">
                        <div class="pa-3 pa-lg-4 w-100">
                            <h3 class="default-fonts" :class="{'font-weight-medium': phoneOnly}">{{exam.name}}</h3>
                            <p v-if="exam.description" class="muted--text medium-text mt-2">
                                {{exam.description}}
                            </p>
                            <v-list class="mx-auto pa-0 mb-4">
                                
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-timer-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>مدة الامتحان</v-list-item-subtitle>
                                        <v-list-item-title>
                                            <span v-if="exam.duration">{{exam.duration}} دقيقة</span>
                                            <span v-else>مفتوح</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item v-if="exam.questions_count">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-file-multiple-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>عدد اﻷسئلة</v-list-item-subtitle>
                                        <v-list-item-title>{{exam.questions_count}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                
                            </v-list>
                            <v-alert v-if="exam.active_session" text type="info" color="warning darken-1">
                                <span class="strong-text--text">لقد بدأت الامتحان بالفعل سابقاً، استكمل اﻵن!</span>
                            </v-alert>
                            <v-btn depressed :loading="loading" dark large block :color="exam.has_session ? (exam.show_result && !exam.active_session ? 'success' : 'strong-text') : 'secondary'" @click="startExam">
                                <v-icon size="23" left>mdi-{{exam.has_session && exam.show_result && !exam.active_session ? 'license' : 'clipboard-arrow-right-outline'}}</v-icon>
                                <b v-if="exam.active_session">استكمال الامتحان</b>
                                <b v-else-if="exam.has_session">
                                    <span v-if="exam.show_result">عرض النتيجة</span>
                                    <span v-else>عرض الجلسة</span>
                                </b>
                                <b v-else>بدء الامتحان</b>
                            </v-btn>
                        </div>
                        <!-- <div v-if="mdAndUp">
                            <img :src="asset('exam-vector.svg', 'img')" style="height: 330px" />
                        </div> -->
                    </div>
                </transition>
            </v-card>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import InfinityWrapper from '@/components/default/infinity-wrapper'
export default {
    name: "Exams",
    components: {
        InfinityWrapper,
    },
    props: {
        examData: {},
    },
    data(){
        return {
            loading: false,
            exam_code: '',

            exam: null,
        }
    },
    computed: {
        ...GlobalComputed,
        course_id(){
            return this.$route.query.course_id;
        },

        enableGenericExams(){
            return !!this.appData.enable_gen_exm;
        },
    },
    watch: {
        loading(loading){
            if (this.phoneOnly){
                this.setLinearLoading(loading);
            }
        }
    },
    methods: {
        ...GlobalMethods,
        mockDate(){
            this.exam = {
                name: 'طريقة لكتابة النصوص في النشر والتصميم الجرافيكي',
                description: 'طريقة لكتابة النصوص في النشر والتصميم الجرافيكي تستخدم بشكل شائع لتوضيح الشكل المرئي للمستند أو الخط دون الاعتماد على محتوى ذي معنى لتوضيح الشكل المرئي للمستند.',
                duration: 60,
            };
        },
        submit(){
            if (!this.loading){
                this.loading = true;
                window.axios.get(`/exams/details?exam_code=${this.exam_code}`).then(response=>{
                    this.loading = false;
                    window.localStorage.setItem('last_exam_code', this.exam_code);
                    window.localStorage.setItem('saved_code_timestamp', (new Date()).getTime());
                    // this.exam_code = '';
                    this.exam = response.data.data;

                }).catch(error=>{
                    if (error && error.response && error.response.data){
                        const msg = error.response.data;
                        if (msg === 'EXAM_NOT_FOUND'){
                            this.showMsg('الكود الذي أدخلته غير صحيح', 'error');
                        }else if (msg === 'EXAM_NOT_STARTED'){
                            this.showMsg('لم يبدأ الامتحان بعد، انتظر حتى يأتي وقت الامتحان', 'error');
                        }else if (msg === 'EXAM_ENDED'){
                            this.showMsg('انتهى الوقت المسموح فيه بدخول الامتحان', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    }
                    this.loading = false;
                })
            }
        },
        startExam(){
            if (!this.loading && this.exam){
                this.loading = true;
                window.axios.post(`/exams/session`, {exam_id: this.exam.id}).then(response=>{
                    this.loading = false;
                    this.$router.push({name: 'exam-session', params: {sessionToken: response.data.data.token, course_id: this.course_id}});

                }).catch(error=>{
                    if (error && error.response && error.response.data){
                        const msg = error.response.data;
                        if (msg === 'EXAM_NOT_ACTIVE'){
                            this.showMsg('ﻻ يمكن بدء الامتحان في الوقت الحالي', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    }
                    this.loading = false;
                })
            }
        }
    },
    created(){
        if (this.examData){
            this.exam = this.examData;
        }
    },
    mounted(){
        this.scrollToTop();
        
        const saved_exam_code = window.localStorage.getItem('last_exam_code');
        if (saved_exam_code){
            const saved_code_timestamp = window.localStorage.getItem('saved_code_timestamp');
            let now = new Date();
            const diff = now.getTime() - saved_code_timestamp;
            const diffInMinutes = Math.floor((diff/1000)/60);
            // if local saved code saved for more than 3 hours, remove it.. else use it as code input value
            if (saved_code_timestamp && diffInMinutes > 180){
                window.localStorage.removeItem('last_exam_code');
                window.localStorage.removeItem('saved_code_timestamp');
            }else{
                this.exam_code = saved_exam_code;
            }
        }


        // window.setTimeout(()=>{
        //     this.mockDate();
        // }, 1000);
    }
};
</script>

<style lang="scss">
.exam-code-input{
    input{
        font-weight: bold;
        letter-spacing: 1px;
    }
}

</style>